export type NumericSizeValueKind = "decimal" | "integer";

/**
 * Restricts in-progress size draft text to numeric characters only.
 * Used for enforced single-key spec fields where the unit is shown separately.
 */
export function sanitizeNumericSizeDraft(
  raw: string,
  kind: NumericSizeValueKind,
): string {
  if (kind === "integer") {
    return raw.replace(/\D/g, "");
  }

  let result = "";
  let seenDot = false;
  for (const ch of raw) {
    if (ch >= "0" && ch <= "9") {
      result += ch;
      continue;
    }
    if (ch === "." && !seenDot) {
      seenDot = true;
      result += ch;
    }
  }
  return result;
}
